import React from "react"
import Swaggerdoc from '../components/swaggerdoc.js'
import api_specs from "../../openapi/api.yaml"

export default () => 
    <Swaggerdoc spec={api_specs} />
